import { Rest } from '../../../../rest/rest_client';
import RestResponse = Rest.RestResponse;
import { Rest_logistics } from '../../Logistics/services/rest_client_logistics';
import { Routes } from '@angular/router';

export namespace Rest_task {
	export interface Delegation extends Rest.Trimmable, Rest.WithId {
		id: number;
		code_name: string;
		info: string;
		client: Rest.Client;
		user: Rest.User;
		routedata: Route[];
		vehicledata: Rest.Vehicle[];
		delegUserData: DelegationUser[];
		customers: Customer[];
		localizations: Rest_logistics.Localization[];
		//usersCheckeds: Rest.User[];
	}

	export interface Route extends Rest.Trimmable, Rest.WithId {
		id: number;
		client: Rest.Client;
		delegation: Delegation;
		//originRoutes: string; //esto tendrán que sera las tiendas
		//originRoute: Rest.POI;
		originName: String;
		originRoute: Rest_logistics.Customer;
		user: Rest.User;
		name: string;
		description: string;
		deleted: boolean;
		checkedvalue: boolean;
		//checkedvalue: boolean;
		routeType: RouteType;
		routeDriversDefault: RouteDriverDefault[];
		attributes: Attributes[];
		zones: Rest.Zone[];
		delegationName:string;
	}

	export interface RouteType extends Rest.Trimmable, Rest.WithId {
		id: number;
		code: string;
		name: string;
		description: string;
	}

	// export interface Userbo extends Rest.Trimmable, Rest.WithId {
	// 	user:Rest.User;
	// }
	// export interface Userapp extends Rest.Trimmable, Rest.WithId {
	// 	user:Rest.User;
	// }

	export interface DelegationUser extends Rest.Trimmable, Rest.WithId {
		id: number;
		client: Rest.Client;
		delegation: Delegation;
		user: Rest.User;
		//checked:boolean;
	}

	export interface RouteDriverDefault extends Rest.Trimmable, Rest.WithId {
		id: number;
		client: Rest.Client;
		route: Rest_task.Route;
		user: Rest.User;
		monday: Boolean;
		tuesday: Boolean;
		wednesday: Boolean;
		thursday: Boolean;
		friday: Boolean;
		saturday: Boolean;
		sunday: Boolean;
		deleted: Boolean;
		dateCreated: Date;
	}

	export interface ReportTypes extends Rest.Trimmable {
		id: number;
		name: string;
	}

	export interface TrainingDates extends Rest.Trimmable, Rest.WithId {
 		lastPredictionTrain: Date;
		lastOrderTrain: Date;
		lastAnomalyTrain: Date;
	}

	export interface HttpClient {
		request<R>(requestConfig: {
			method: string;
			url: string;
			queryParams?: any;
			data?: any;
			copyFn?: (data: R) => R;
		}): Rest.RestResponse<R>;
	}

	/**
	 * PREDICTIONS INTERFACES
	 */
	export interface ProcessStatusReport {
		id: string;
		type: TypeEnum;
		executionStartDate: Date;
		executionEndDate: Date;
		status: StatusEnum;
		executionMetrics: ExecutionMetrics;
	}

	export interface Pipeline {
		multiplyStep: string;
	}

	export enum TypeEnum {
		PUNCTUAL = 'PUNCTUAL',
		STREAMING = 'STREAMING',
	}

	export enum StatusEnum {
		PENDING = 'PENDING',
		RUNNING = 'RUNNING',
		SUCCESS = 'SUCCESS',
		FAIL = 'FAIL',
	}

	export enum Source {
		FINITE = 'FINITE',
		STREAMING = 'STREAMING',
	}

	export enum NotificationType {
		ORDER_RECEIVED = 'ORDER_RECEIVED',
		ORDER_CHARGED = 'ORDER_CHARGED',
		ORDER_ON_THE_WAY = 'ORDER_ON_THE_WAY',
		ORDER_DELIVERED = 'ORDER_DELIVERED',
		ORDER_DELAYED = 'ORDER_DELAYED',
		ORDER_NOT_DELIVERED = 'ORDER_NOT_DELIVERED',
	}

	export enum NotificationParam {
		ORDER_DATE = 'ORDER_DATE',
		DELIVERED_DATE = 'DELIVERED_DATE',
		PRODUCTS = 'PRODUCTS',
		DELAY_TIME = 'DELAY_TIME',
		CUSTOMER_NAME = 'CUSTOMER_NAME',
		MAP_URL = 'MAP_URL'
	}

	export enum NotificationReceiver {
		CUSTOMER = 'CUSTOMER',
		USER = 'USER',
	}

	export interface NotificationParamDetail {
		mail: NotificationParam[];
		mailSubject: NotificationParam[];
		sms: NotificationParam[];
	}

	export const NotificationParamsMap: Record<NotificationType, NotificationParamDetail> = {
		[NotificationType.ORDER_RECEIVED]: {
			mail: [NotificationParam.CUSTOMER_NAME, NotificationParam.PRODUCTS, NotificationParam.MAP_URL],
			sms: [NotificationParam.MAP_URL],
			mailSubject: [],
		},
		[NotificationType.ORDER_CHARGED]: {
			mail: [NotificationParam.DELIVERED_DATE, NotificationParam.PRODUCTS],
			sms: [NotificationParam.DELIVERED_DATE],
			mailSubject: [NotificationParam.DELIVERED_DATE],
		},
		[NotificationType.ORDER_ON_THE_WAY]: {
			mail: [NotificationParam.DELIVERED_DATE, NotificationParam.PRODUCTS],
			sms: [NotificationParam.DELIVERED_DATE],
			mailSubject: [NotificationParam.DELIVERED_DATE],
		},
		[NotificationType.ORDER_DELIVERED]: {
			mail: [NotificationParam.DELIVERED_DATE, NotificationParam.PRODUCTS],
			sms: [NotificationParam.DELIVERED_DATE],
			mailSubject: [NotificationParam.DELIVERED_DATE],
		},
		[NotificationType.ORDER_DELAYED]: {
			mail: [NotificationParam.DELAY_TIME],
			sms:  [NotificationParam.DELAY_TIME],
			mailSubject: [NotificationParam.DELAY_TIME],
		},
		[NotificationType.ORDER_NOT_DELIVERED]: {
			mail: [],
			sms: [],
			mailSubject: [],
		},
	};

	export interface ExecutionMetrics {
		source: Source;
		pipeline: Pipeline;
		sink: string;
	}
	export interface Demand {
		customerCode: string;
		productId: string;
		historic: Map<string, Map<string, number>>;
	}

	// TODO: Delete or uncomment when predictions are implemented
	// export interface Historic {
	// 	[articleId: string]: {
	// 		[date: string]: number;
	// 	};
	// }

	export interface Order {
		orderId: number;
		date_created: string;
		customer: Customer;
		products: Product[];
	}

	export interface Customer {
		customerCode: number;
		deliveryPostCode: string;
		deliveryCity: string;
		name1: string;
		deleted: boolean;
	}

	export interface Attributes {
		id: number;
		code: string;
		name: string;
		description: string;
		deleted: boolean;
		client: Rest.Client;
	}
	export interface Product {
		productCode: string;
		quantity: number;
		unitOfMeasure: string;
		productFamily: string;
	}

	export interface OrderResult {
		order_id: number;
		group: number;
	}

	export interface ProcessPID {
		code: string;
		pid: string;
	}

	export interface Anomaly {
		kafkaServer: string;
		vehiclesToListen: number[];
	}

	export interface AnomalyRequest {
		vehicles: string[];
	}

	export interface Telemetry {
		temperature: string;
		warning: string;
		timestamp: string;
	}

	export interface Article {
		id: number;
		code: string;
		name: string;
		client: Rest.Client;
	}

	// ARTICLE RATES INTERFACES
	export interface ArticleRates {
		id: number;
		code: string;
		name: string;
		type: ArticleType;
		quantity: number;
		client: Rest.Client;
		tariff: Rate[];
	}

	export interface ArticleType {
		id: number;
		client: Rest.Client;
		code: string;
	}

	export interface Rate {
		id: number;
		name: string;
		dateStart: Date;
		dateEnd: Date;
		price: number;
		fleet: Rest.Fleet;
	}

	export interface DataTransfer {
		sourceId: number;
		destinationId: number;
	}

	export interface Notification extends Rest.Trimmable, Rest.WithId {
		notification: Rest_logistics.Customer;
		//id: number;
		customer: Rest_logistics.Customer;
		isCustomerDefault: Boolean;
		notifyBySMS: Boolean;
		notifyByEmail: Boolean;
		mailSubject: String;
		mailBody: String;
		smsMessage: String;
		sender: String;
		type: NotificationType;
		receiver: NotificationReceiver;
		isSelected: Boolean;
		params: NotificationParamDetail;
	}

	export interface NotificationLog extends Rest.Trimmable, Rest.WithId {
		order: Rest_logistics.Order,
		type: NotificationType;
		sendingDate: Date;
		mailReceiver: String;
		smsReveiver: String;
		receiverCode: String;
	}

	export interface UserPlanner extends Rest.Trimmable, Rest.WithId {
		user: Rest.User;
		vehicle: Rest.Vehicle;
		attributes: Attributes[];
		fixedCost: number; //double
		kmCost: number; //double
		hourCost: number; //double
		extraHourCost: number; //double
		breakEveryTime: string; //string
		extraTimeAllowed: string; //string
		routeDistanceLimit: number; //int
		scheduleStart: string; //time
		scheduleEnd: string; //time
		startLocalization: Rest_logistics.Localization; //int
		endLocalization: Rest_logistics.Localization; //int
		radialCost: boolean;
		radialCosts: UserRadialCost[];
		//zone: Zone;
		zones: Zone[];
	}



	export interface UserRadialCost extends Rest.Trimmable, Rest.WithId {
 		startKm: number;
		endKm: number;
		cost: number; //double	 
	}

	export class RestApplicationClient {
		constructor(protected httpClient: HttpClient) {}

		/** DELEGATIONS  **/
		Delegation_create(arg0: Delegation): Rest.RestResponse<Rest_task.Delegation> {
			return this.httpClient.request({
				method: 'POST',
				url: uriEncoding`api/delegations`,
				data: arg0,
			});
		}

		Delegation_getPage(arg0: Rest.ListPaginationRequest): Rest.RestResponse<Rest.Page<Rest_task.Delegation>> {
			return this.httpClient.request({
				method: 'POST',
				url: uriEncoding`api/delegations/page`,
				data: arg0,
			});
		}

		Delegation_find(uid: string, queryParams?: { id?: number }): RestResponse<Rest_task.Delegation> {
			return this.httpClient.request({
				method: 'GET',
				url: uriEncoding`api/delegations/${uid}`,
				queryParams: queryParams,
			});
		}

		Delegation_update(arg0: Delegation): Rest.RestResponse<Rest_task.Delegation> {
			return this.httpClient.request({
				method: 'PUT',
				url: uriEncoding`api/delegations`,
				data: arg0,
			});
		}

		Delegation_delete(arg0: Delegation): Rest.RestResponse<boolean> {
			return this.httpClient.request({
				method: 'DELETE',
				url: uriEncoding`api/delegations/delete`,
				data: arg0,
			});
		}

		delegationGetAllDataTask(id: number): Rest.RestResponse<Rest_task.Delegation> {
			return this.httpClient.request({
				method: 'GET',
				url: uriEncoding`api/delegations/allDataTask/${id}`,
			});
		}

		delegationAddAllDataTask(arg0: Rest_task.Delegation): Rest.RestResponse<Rest_task.Delegation> {
			return this.httpClient.request({
				method: 'POST',
				url: uriEncoding`api/delegations/AddAllDataTask`,
				data: arg0,
			});
		}

		delegationUpdateAllDataTask(arg1: Delegation): Rest.RestResponse<Rest_task.Delegation> {
			return this.httpClient.request({
				method: 'PUT',
				url: uriEncoding`api/delegations/UpdateAllDataTask`,
				data: arg1,
			});
		}
		/*
			Delegation_getAvailableUserAssignations(arg0: Rest.ListPaginationRequest): Rest.RestResponse<Rest.Page<Rest_task.Delegation>> {
				return this.httpClient.request({
					method: 'POST',
					url: uriEncoding`api/delegations/user/assignations`,
					data: arg0,
				});
			} */

		User_getPage(arg0: Rest.ListPaginationRequest, type: number): Rest.RestResponse<Rest.Page<Rest.User>> {
			return this.httpClient.request({
				method: 'POST',
				url: uriEncoding`api/user/pageTask/${type}`,
				data: arg0,
			});
		}
		User_find(uid: string, queryParams?: { id?: number }): RestResponse<Rest.User> {
			return this.httpClient.request({
				method: 'GET',
				url: uriEncoding`api/user/task/${uid}`,
				queryParams: queryParams,
			});
		}
		User_create(arg0: Rest.User, type: number): Rest.RestResponse<Rest.User> {
			return this.httpClient.request({
				method: 'POST',
				url: uriEncoding`api/user/create/task/${type}`,
				data: arg0,
			});
		}

		User_update(arg0: Rest.User, type: number): Rest.RestResponse<Rest.User> {
			return this.httpClient.request({
				method: 'PUT',
				url: uriEncoding`api/user/update/task/${type}`,
				data: arg0,
			});
		}

		User_delete(arg0: { userId: number; projectTypeId: number }): Rest.RestResponse<void> {
			return this.httpClient.request({
				method: 'DELETE',
				url: uriEncoding`api/user/delete/task`,
				data: arg0,
			});
		}

		Userbo_getPermissions(): Rest.RestResponse<Rest.Profile[]> {
			return this.httpClient.request({
				method: 'GET',
				url: uriEncoding`/api/task/roleprofilehierarchy`,
			});
		}

		User_setPlannerFeatures(userPlanner: UserPlanner, userId: number): Rest.RestResponse<Rest.GenericResp> {
			return this.httpClient.request({
				method: 'POST',
				url: uriEncoding`api/task/userplanner/features/${userId}`,
				data: userPlanner,
			});
		}

		User_setPlannerCosts(userPlanner: UserPlanner, userId: number): Rest.RestResponse<Rest.GenericResp> {
			return this.httpClient.request({
				method: 'POST',
				url: uriEncoding`api/task/userplanner/costs/${userId}`,
				data: userPlanner,
			});
		}

		User_setPlannerLocalizations(userPlanner: UserPlanner, userId: number): Rest.RestResponse<Rest.GenericResp> {
			return this.httpClient.request({
				method: 'POST',
				url: uriEncoding`api/task/userplanner/localizations/${userId}`,
				data: userPlanner,
			});
		}

		/** USER BO/APP **/
		/*
		 Userboapp_create(arg0: Delegation, arg2:number): Rest.RestResponse<Rest.User> {
			return this.httpClient.request({
				method: 'POST',
				url: uriEncoding`api/user`,
				data: arg0,
			});
	
		 }
	
		Userboapp_getPage(arg0: Rest.ListPaginationRequest, type:number): Rest.RestResponse<Rest.Page<Rest.User>> {
			return this.httpClient.request({
				method: 'POST',
				url: uriEncoding`api/user/pageboapp/${type}`,
				data: arg0,
			});
		}
	
		 Userboapp_update(arg0: Delegation): Rest.RestResponse<Rest.User> {
			return this.httpClient.request({
				method: 'PUT',
				url: uriEncoding`api/user`,
				data: arg0,
			});
		}
	
		Userboapp_getPageAndFilters(arg0: Rest.ListPaginationRequest, type:number): Rest.RestResponse<Rest.ListPageAndFilters<Rest.User>> {
			return this.httpClient.request({
				method: 'POST',
				url: uriEncoding`api/user/pageAndFiltersboapp/${type}`,
				data: arg0,
			});
		} */

		/*Userboapp(type:number): Rest.RestResponse<Rest.User[]> {
			return this.httpClient.request({
				method: 'POST',
				url: uriEncoding`api/user/userDriversTask/${type}`,
			});
		}*/

		Vehicle_getPage(arg0: Rest.ListPaginationRequest): Rest.RestResponse<Rest.Page<Rest.Vehicle>> {
			return this.httpClient.request({
				method: 'POST',
				url: uriEncoding`api/task/vehicle/page`,
				data: arg0,
			});
		}

		Vehicle_create(arg0: Rest.Vehicle): Rest.RestResponse<Rest.GenericResp<Rest.Vehicle>> {
			return this.httpClient.request({
				method: 'POST',
				url: uriEncoding`api/task/vehicle/create`,
				data: arg0,
			});
		}
		Vehicle_update(arg0: Rest.Vehicle): Rest.RestResponse<Rest.GenericResp<Rest.Vehicle>> {
			return this.httpClient.request({
				method: 'PUT',
				url: uriEncoding`api/task/vehicle/update`,
				data: arg0,
			});
		}

		Vehicle_join(arg0: Rest_task.DataTransfer): Rest.RestResponse<Rest.GenericResp> {
			return this.httpClient.request({
				method: 'POST',
				url: uriEncoding`api/task/vehicle/join`,
				data: arg0,
			});
		}
		Vehicle_transfer(arg0: Rest_task.DataTransfer): Rest.RestResponse<Rest.GenericResp> {
			return this.httpClient.request({
				method: 'POST',
				url: uriEncoding`api/task/vehicle/transfer`,
				data: arg0,
			});
		}

		//Routes
		/**
		 * HTTP POST /api/user/pageAndFilters
		 * Java method: org.eurecat.atlantis_cycle.coordination_module.rest.ajax.RouteController.getPage
		 */
		Route_getPage(arg0: Rest.ListPaginationRequest): Rest.RestResponse<Rest.Page<Rest_task.Route>> {
			return this.httpClient.request({
				method: 'POST',
				url: uriEncoding`api/task/routes/page`,
				data: arg0,
			});
		}

		/**
		 * HTTP POST /api/user/pageAndFilters
		 * Java method: org.eurecat.atlantis_cycle.coordination_module.rest.ajax.RouteController.User_getPageAndFilters
		 */
		Route_getPageAndFilters(
			arg0: Rest.ListPaginationRequest
		): RestResponse<Rest.ListPageAndFilters<Rest_task.Route>> {
			return this.httpClient.request({
				method: 'POST',
				url: uriEncoding`api/task/routes/pageAndFilters`,
				data: arg0,
			});
		}

		Route_find(uid: string, queryParams?: { id?: number }): RestResponse<Rest_task.Route> {
			return this.httpClient.request({
				method: 'GET',
				url: uriEncoding`api/task/routes/${uid}`,
				queryParams: queryParams,
			});
		}
		Route_create(arg0: Route): Rest.RestResponse<Rest.GenericResp<Rest_task.Route>> {
			return this.httpClient.request({
				method: 'POST',
				url: uriEncoding`api/task/routes`,
				data: arg0,
			});
		}
		Route_update(arg0: Route): Rest.RestResponse<Rest.GenericResp<Rest_task.Route>> {
			return this.httpClient.request({
				method: 'PUT',
				url: uriEncoding`api/task/routes`,
				data: arg0,
			});
		}

		// Route_create(arg0: Route): Rest.RestResponse<Rest_task.Route> {
		// 		return this.httpClient.request({
		// 			method: 'POST',
		// 			url: uriEncoding`api/task/routes`,
		// 			data: arg0,
		// 		});
		// 	}
		// Route_update(arg0: Route): Rest.RestResponse<Rest_task.Route> {
		// 		return this.httpClient.request({
		// 			method: 'PUT',
		// 			url: uriEncoding`api/task/routes`,
		// 			data: arg0,
		// 		});
		// 	}

		Route_changeStatus(arg0: number[], queryParams?: { status?: boolean }): RestResponse<any> {
			return this.httpClient.request({
				method: 'PUT',
				url: uriEncoding`api/task/routes/status`,
				queryParams: queryParams,
				data: arg0,
			});
		}

		Route_delete(arg0: Route): Rest.RestResponse<any> {
			return this.httpClient.request({
				method: 'DELETE',
				url: uriEncoding`api/task/routes`,
				data: arg0,
			});
		}

		//Route Types
		RouteType_getPage(arg0: Rest.ListPaginationRequest): Rest.RestResponse<Rest.Page<RouteType>> {
			return this.httpClient.request({
				method: 'POST',
				url: uriEncoding`api/task/routes/types/page`,
				data: arg0,
			});
		}

		RouteType_findByUserClient(): RestResponse<RouteType[]> {
			return this.httpClient.request({
				method: 'GET',
				url: uriEncoding`api/task/routes/types`,
			});
		}

		/*
		 **  PREDICTIONS METHODS
		 */
		getStatusPID(pid: string): RestResponse<ProcessStatusReport> {
			return this.httpClient.request({
				method: 'GET',
				url: uriEncoding`api/logisticsAi/process/${pid}`,
			});
		}

		prediction_find(arg0: Demand): RestResponse<Map<string, number>> {
			return this.httpClient.request({
				method: 'POST',
				url: uriEncoding`api/logisticsAi/demand`,
				data: arg0,
			});
		}

		getArticlesList(productId: string): RestResponse<Map<string, Map<string, number>>> {
			return this.httpClient.request({
				method: 'POST',
				url: uriEncoding`api/logisticsAi/neighbours/${productId}`,
			});
		}

		getHistoricArticleData(articles: Article[]): RestResponse<Map<string, Map<string, number>>> {
			return this.httpClient.request({
				method: 'POST',
				url: 'api/task/article/demandcount?days=7',
				data: articles,
			});
		}

		getOrder(arg0: Order): RestResponse<OrderResult> {
			return this.httpClient.request({
				method: 'POST',
				url: uriEncoding`api/logisticsAi/order`,
				data: arg0,
			});
		}

		getAnomalyPID(arg0: Anomaly): RestResponse<ProcessPID> {
			return this.httpClient.request({
				method: 'POST',
				url: uriEncoding`api/logisticsAi/anomaly`,
				data: arg0,
			});
		}

		getAnomaly(arg0: AnomalyRequest): RestResponse<Map<string, Telemetry[]>> {
			return this.httpClient.request({
				method: 'POST',
				url: uriEncoding`api/logisticsAi/anomaly/result`,
				data: arg0,
			});
		}

		getArticlesPage(arg0: Rest.ListPaginationRequest): RestResponse<Rest.Page<Article>> {
			return this.httpClient.request({
				method: 'POST',
				url: uriEncoding`api/task/article/page`,
				data: arg0,
			});
		}

		// TRANING METHODS
		trainAnomaliesModel(vehicleId: number): RestResponse<Rest.GenericResp> {
			return this.httpClient.request({
				method: 'POST',
				url: uriEncoding`/api/logisticsAi/anomaly/train/${vehicleId.toString()}`,
			});
		}

		trainOrdersModel(): RestResponse<Rest.GenericResp> {
			return this.httpClient.request({
				method: 'POST',
				url: uriEncoding`/api/logisticsAi/orders/train`,
			});
		}

		trainDemandsModel(): RestResponse<Rest.GenericResp> {
			return this.httpClient.request({
				method: 'POST',
				url: uriEncoding`/api/logisticsAi/demand/train`,
			});
		}

		getTrainingDates (clientId: number): RestResponse<Rest_task.TrainingDates> {
			return this.httpClient.request({
				method: 'GET',
				url: uriEncoding`api/logisticsAi/training/dates/${clientId.toString()}`,
			});
		}

		// ARTICLE RATES METHODS
		getArticleRatesPage(arg0: Rest.ListPaginationRequest): RestResponse<Rest.Page<ArticleRates>> {
			return this.httpClient.request({
				method: 'POST',
				url: uriEncoding`api/task/article/page`,
				data: arg0,
			});
		}

		ArticleRates_find(uid: string, queryParams?: { id?: number }): RestResponse<Rest_task.ArticleRates> {
			return this.httpClient.request({
				method: 'GET',
				url: uriEncoding`api/task/article/${uid}`,
				queryParams: queryParams,
			});
		}

		ArticleRates_deleteRate(uid: string): RestResponse<Rest.GenericResp<Rest_task.Rate>> {
			return this.httpClient.request({
				method: 'DELETE',
				url: uriEncoding`api/task/tariff/${uid}`,
			});
		}

		createArticleRates(arg0: ArticleRates): Rest.RestResponse<Rest.GenericResp<Rest_task.ArticleRates>> {
			return this.httpClient.request({
				method: 'POST',
				url: uriEncoding`api/task/article`,
				data: arg0,
			});
		}

		updateArticleRates(arg0: ArticleRates): Rest.RestResponse<Rest.GenericResp<Rest_task.ArticleRates>> {
			return this.httpClient.request({
				method: 'PUT',
				url: uriEncoding`api/task/article`,
				data: arg0,
			});
		}

		ArticleRates_changeStatus(arg0: number[], queryParams?: { status?: boolean }): RestResponse<any> {
			return this.httpClient.request({
				method: 'PUT',
				url: uriEncoding`api/task/article/status`,
				queryParams: queryParams,
				data: arg0,
			});
		}

		getRatesType(): Rest.RestResponse<Rest_task.ArticleType[]> {
			return this.httpClient.request({
				method: 'GET',
				url: uriEncoding`api/task/article/typeArticles`,
			});
		}

		// ATTRIBUTES RATES METHODS
		getAttributesPage(arg0: Rest.ListPaginationRequest): RestResponse<Rest.Page<Attributes>> {
			return this.httpClient.request({
				method: 'POST',
				url: uriEncoding`api/task/attributes/page`,
				data: arg0,
			});
		}

		Attributes_find(uid: string, queryParams?: { id?: number }): RestResponse<Rest_task.Attributes> {
			return this.httpClient.request({
				method: 'GET',
				url: uriEncoding`api/task/attributes/${uid}`,
				queryParams: queryParams,
			});
		}
		createAttributes(arg0: Attributes): Rest.RestResponse<Rest.GenericResp<Rest_task.Attributes>> {
			return this.httpClient.request({
				method: 'POST',
				url: uriEncoding`api/task/attributes`,
				data: arg0,
			});
		}

		updateAttributes(arg0: Attributes): Rest.RestResponse<Rest.GenericResp<Rest_task.Attributes>> {
			return this.httpClient.request({
				method: 'PUT',
				url: uriEncoding`api/task/attributes`,
				data: arg0,
			});
		}

		Attributes_changeStatus(arg0: number[], queryParams?: { status?: boolean }): RestResponse<any> {
			return this.httpClient.request({
				method: 'PUT',
				url: uriEncoding`api/task/attributes/status`,
				queryParams: queryParams,
				data: arg0,
			});
		}
	}
	function uriEncoding(template: TemplateStringsArray, ...substitutions: any[]): string {
		let result = '';
		for (let i = 0; i < substitutions.length; i++) {
			result += template[i];
			result += encodeURIComponent(substitutions[i]);
		}
		result += template[template.length - 1];
		return result;
	}


}
